import { createPopper } from '@popperjs/core'
import { nextTick as vueNextTick, createApp as createVue } from 'vue'
import $ from 'jquery'
import MiniProfile from '../components/mini-profile.vue'

let miniProfilePopper = false,
	miniProfileVue = false

const showOnWeb = ( user, ev ) => {
		//console.log( 'showMiniProfile mini-profile-handler.js', user.props.name, ev )

		if( !miniProfileVue ){
			const $miniProfile = $( '<div><mini-profile :user="user" /></div>' ).appendTo( 'body' )

			miniProfileVue = createVue({
				data: () => ({
					user: false
				}),
				components: {
					MiniProfile
				}
			})
				.mount( $miniProfile[0] )
		}

		vueNextTick( () => {
			$( '#mini-profile' ).show()

			miniProfileVue.user = user

			/* {
				miniProfilePopper.reference = $this[0]
				miniProfilePopper.state.reset = true
				miniProfilePopper.update()
				miniProfilePopper.forceUpdate()
				console.log( miniProfilePopper )
			} */
			if( miniProfilePopper ){
				miniProfilePopper.destroy()
				miniProfilePopper = false
			}
			miniProfilePopper = createPopper( $( ev.target ).closest( '.user' )[0], $( '#mini-profile' )[0], { // change this to just create one and update it...
				placement: 'left-start',
				scroll: false,
				modifiers: [
					{
						name: 'preventOverflow',
						options: {
							boundary: window
						}
					},
					{
						name: 'flip',
						enabled: false
					},
					{
						name: 'arrow',
						enabled: false
					}

				]
			})
		})
	},
	showOnDesktop = ( user, ev ) => {
		const $target = $( ev.target ).closest( '.user' )

		window.ipc.send( 'miniProfileOperation',
			user.props.id,
			{
				screenX: ev.screenX,
				screenY: ev.screenY,
				clientX: ev.clientX,
				clientY: ev.clientY,
				targetPosition: { x: $target.position().left, y: $target.position().top },
				targetSize: { width: $target.width(), height: $target.height() }
			}
		)
	},
	hideOnWeb = ( ev ) => {
		const $miniProfile = $( '#mini-profile' )
		if( $.contains( $miniProfile[0], ev.relatedTarget ) ){
			$miniProfile.one( 'mouseleave', () => {
				$miniProfile.hide()
			})
		} else {
			$miniProfile.hide()
		}
	},
	hideOnDesktop = ( ev ) => {
		console.log( 'hideMiniProfile mini-profile-handler.js', ev )
	},
	IS_ELECTRON = process.env.IS_ELECTRON

export const showMiniProfile = IS_ELECTRON ? showOnDesktop : showOnWeb,
	hideMiniProfile = IS_ELECTRON ? hideOnDesktop : hideOnWeb

export default {
	show: IS_ELECTRON ? showOnDesktop : showOnWeb,
	hide: IS_ELECTRON ? hideOnDesktop : hideOnWeb
}
